@if (settings) {
    @if (type() === 'badge') {
        <!-- ----- Only Badge ------------------------- -->
        <span
            [placement]="settings.placement"
            [ngbTooltip]="settings.tooltip"
            container="body"
            style="opacity: 0.75"
            class="m-badge"
            [ngClass]="settings.class"
        ></span>
    } @else {
        <!-- ----- Badge With Text ------------------------- -->
        <span container="body" placement="right" style="opacity: 0.75" class="m-badge p-1" [ngClass]="settings.class">
            {{ settings?.tooltip | uppercase }}
        </span>
    }
}
